import {Graphics, Sprite} from 'pixi.js';
import {Slider} from './instument_top_block/Slider';
import {ColorPicker} from './instument_top_block/ColorPicker';
import {DrawInstrumentMenuData} from './draw_buttons/DrawInstrumentMenuData';
import {gsap, Sine} from 'gsap';

export class InstrumentTopBlock extends Sprite
{
    private back: Graphics;
    public slider: Slider;
    public colorPicker: ColorPicker;
    private colorPickerMask: Graphics;
    private backTween: gsap.core.Tween | undefined;
    private sliderTween: gsap.core.Tween | undefined;
    private colorPickerTween: gsap.core.Tween | undefined;

    constructor() {
        super();

        this.back = new Graphics();
        this.colorPickerMask = new Graphics();
        this.backWidth = 520;
        this.addChild(this.back);

        this.slider = new Slider();
        this.colorPicker = new ColorPicker();

        this.addChild(this.slider).x = -220;
        this.addChild(this.colorPicker).x = 95;
        this.addChild(this.colorPickerMask);
        this.colorPicker.mask = this.colorPickerMask;

    }

    private _backWidth: number = 0;

    get backWidth(): number {
        return this._backWidth;
    }

    set backWidth(value: number) {
        this._backWidth = value;
        let width: number = value;
        let height: number = 55;

        this.back.clear();
        this.back.beginFill(0x25282d, 1);
        this.back.drawRoundedRect(-width / 2, -height / 2, width, height, 10);
        this.back.endFill();

        this.colorPickerMask.clear();
        this.colorPickerMask.beginFill(0xffffff, 1);
        this.colorPickerMask.drawRoundedRect(-width / 2, -height / 2, width, height, 10);
        this.colorPickerMask.endFill();
    }

    async setInstrument(instrument: DrawInstrumentMenuData) {
        let useSizeNormalized: boolean = !!instrument.useSize;
        let useColorNormalized: boolean = !!instrument.useColor;
        let newVisible: boolean = useSizeNormalized || useColorNormalized;

        this.slider.visible = useSizeNormalized;
        this.backTween && this.backTween.pause();
        this.sliderTween && this.sliderTween.pause();
        await this.slider.setIconType(instrument.sliderIconType);
        if (this.visible != newVisible) {
            this.backWidth = useColorNormalized ? 520 : 200;
            this.slider.x = useColorNormalized ? -220 : -55;
            this.colorPicker.x = useColorNormalized ? 95 : 95 + (-55 - (-220));
        } else {
            await Promise.all([
                new Promise(resolve => this.backTween = gsap.to(this, .2, {
                    backWidth: useColorNormalized ? 520 : 200,
                    ease: Sine.easeInOut,
                    onComplete: resolve
                })),
                new Promise(resolve => this.sliderTween = gsap.to(this.slider, .2, {
                    x: useColorNormalized ? -220 : -55,
                    ease: Sine.easeInOut,
                    onComplete: resolve
                })),
                new Promise(resolve => this.colorPickerTween = gsap.to(this.colorPicker, .2, {
                    x: useColorNormalized ? 95 : 95 + (-55 - (-220)),
                    ease: Sine.easeInOut,
                    onComplete: resolve
                }))
            ]);
        }
        this.visible = newVisible;
    }
}
